<template>
    <CommonBox1 :title="titles[updateType]" @close="$emit('close')" @submit="$emit('close')">
        <el-form ref="form" label-width="200px" :model="initForm" :rules="rules">
            <el-form-item label="Company Name" prop="CompanyName">
                <el-input v-model="initForm.CompanyName" :disabled="true"></el-input>
            </el-form-item>

            <el-form-item label="First Name" prop="FirstName">
                <el-input v-model="initForm.FirstName" :disabled="true"></el-input>
            </el-form-item>

            <el-form-item label="Last Name">
                <el-input v-model="initForm.LastName" :disabled="true"></el-input>
            </el-form-item>
        
            <el-form-item label="Email" prop="Email">
                <el-input v-model="initForm.Email" :disabled="true"></el-input>
            </el-form-item> 
       
            <el-form-item label="Company Website" prop="CompanyWebsite">
                <el-input v-model="initForm.CompanyWebsite" :disabled="true"></el-input>
            </el-form-item>

            <el-form-item label="Company Description" prop="CompanyDescription">
                    <el-input v-model="initForm.CompanyDescription" :disabled="true"></el-input>
            </el-form-item> 

            <el-form-item label="Country" prop="Country">
                <el-input v-model="initForm.Country" :disabled="true"></el-input>
            </el-form-item>

            <el-form-item label="City" prop="City">
                <el-input v-model="initForm.City" :disabled="true"></el-input>
            </el-form-item>

            <el-form-item label="Phone" prop="Phone">
                <el-input v-model="initForm.Phone" :disabled="true"></el-input>
            </el-form-item>
        
        <el-form-item label="Grade" prop="Grade">
                <el-select v-model="initForm.Grade" placeholder="" :disabled="true">
                    <el-option
                        v-for="item in grades"
                        :key="item.key"
                        :label="item.value"
                        :value="item.key">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="ACIA" prop="ACIA">
                <el-input v-model="initForm.ACIA" :disabled="true"></el-input>
            </el-form-item>

            <el-form-item label="ACIE" prop="ACIE">
                <el-input v-model="initForm.ACIE" :disabled="true"></el-input>
            </el-form-item>

            <el-form-item label="ACIP" prop="ACIP">
                <el-input v-model="initForm.ACIP" :disabled="true"></el-input>
            </el-form-item>

        <el-form-item label="Sales Representative" prop="Account">
                <el-select v-model="initForm.Account" placeholder="" multiple  :disabled="true">
                     <el-option
                        v-for="item in accountList"
                        :key="item.ID"
                        :label="item.AccountFullName" 
                        :value="item.ID">
                    </el-option> 
                </el-select>
        </el-form-item>

         <span v-if="initForm.Grade === '4'">
            <el-form-item label="Partner" prop="Partner">
                <el-select v-model="initForm.Partner" placeholder="" multiple :disabled="true">
                    <el-option
                        v-for="item in partnerList"
                        :key="item[0].ID"
                        :label="item[0].PartnerFullName"
                        :value="item[0].ID">
                    </el-option>
                </el-select>
            </el-form-item>
        </span>

        <span v-if="initForm.Grade !== '4'">
            <el-form-item label="Distributor" prop="Partner">
                <el-select v-model="initForm.Partner" placeholder="" :disabled="true">
                    <el-option
                        v-for="item in distributorList"
                        :key="item[0].ID"
                        :label="item[0].DistributorFullName"
                        :value="item[0].ID">
                    </el-option>
                </el-select>
            </el-form-item>
        </span>

        </el-form> 
    </CommonBox1>
</template>

<script>
import CommonBox1 from "@/components/common/CommonBox1.vue";
import { grades } from "@/utils/grade.data.js";
export default {
    components:{
        CommonBox1
    },
    props:{
        updateType:{},
        initForm:{}
    },
    data () {
        return {
            titles:{
                edit:"View Partner"
            },
            rules:{
                CompanyName:[{required: true, message: 'Please enter a companyName', trigger: 'blur'}],
                FirstName:[{required: true, message: 'Please enter a firstName', trigger: 'blur'}],
                /* LastName:[{required: true, message: 'Please enter a lastName', trigger: 'blur'}], */
                Email:[{ required: true, message: 'Please input the email address', trigger: 'blur' },
                    { type: 'email', message: 'Please input the correct email address', trigger: ['blur', 'change'] }],
                Country:[{required: true, message: 'Please enter a country', trigger: 'blur'}],
                City:[{required: true, message: 'Please enter a city', trigger: 'blur'}],
                ACIA:[{required: true, message: 'Please enter a ACIA', trigger: 'blur'}],
                ACIE:[{required: true, message: 'Please enter a ACIE', trigger: 'blur'}],
                ACIP:[{required: true, message: 'Please enter a ACIP', trigger: 'blur'}],
                Grade:[{required: true, message: 'Please enter  an email', trigger: 'blur'}],
                Account:[{required: true, message: 'Please enter a password', trigger: 'blur'}]
            },
            grades,
            accountList:[],
            partnerList:[],
            distributorList:[]
        };
    },
    mounted () {
        this.getAccountBindingPartner();
        this.getAccountBindingDistributor();
        this.$http.get("getAllAccount",{},(data)=>{
            this.accountList = data.data;
        });
    },
    methods:{
        getAccountBindingPartner () {
            this.$http.get("getAccountBindingPartner",{},(data)=>{
                this.partnerList = data.data;
            });
        },
        getAccountBindingDistributor () {
            this.$http.get("getAccountBindingDistributor",{},(data)=>{
                this.distributorList = data.data;
            });
        }
    }
};
</script>
